export const SET_NAVIGATOR_DASHBOARD_SLUG = 'Navigator / SET_NAVIGATOR_DASHBOARD_SLUG';

export interface NavigatorState {
  dashboardSlug: string;
}
